import { FC } from 'react';
// import { useMethods } from '@lhb/hook';
import styles from './index.module.less';
import Block from './Block';
// import IconFont from 'src/common/components/Base/IconFont/index';

/**
 * 分析完成结果-核心指标分析/店铺测评情况
 * @description
 * @demo
 */
const Component:FC<{
  reload?: () => void;
}> = () => {

  /* state */

  /* hooks */

  /* methods */
  // const methods = useMethods({

  //   handleRepredict() {
  //     reload?.();
  //   },

  // });

  // const list = [
  //   {
  //     value: '3731',
  //     unit: '人/日',
  //     label: '过店客流',
  //     img: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/passenger_flow2.png`,
  //   },
  //   {
  //     value: '3',
  //     unit: '元/人',
  //     label: '进店成本',
  //     img: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/entry_cost2.png`,
  //     footer: <span className={styles.redTip}>高于基线1.2元/人</span>
  //   },
  //   {
  //     value: '11086',
  //     unit: '元',
  //     label: '预计日销售额',
  //     img: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/expected_daily_sales_revenue2.png`,
  //     footer: <div className={styles.repredict} onClick={methods.handleRepredict}>
  //       <span className={styles.text}>重新预测</span>
  //       <IconFont iconHref='iconmove-down-copy' className={styles.icon} />
  //     </div>
  //   },
  //   {
  //     value: '13.7',
  //     unit: '个月',
  //     label: '回本周期',
  //     img: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/payback_period2.png`,
  //   },
  //   {
  //     value: '18500',
  //     unit: '元',
  //     label: '建议月租金',
  //     img: `${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/suggested_monthly_rent2.png`,
  //   },
  // ];

  return (<Block className={styles.keyMetrics}>
    <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/report-result/key_metrics_content.png`} className={styles.contentImg} />
  </Block>);
  // return (<Block className={styles.keyMetrics}>
  //   <div className={styles.title}>核心指标分析</div>
  //   {/* <div className={styles.line}></div> */}

  //   <div className={styles.container}>
  //     <div className={styles.entryRate}>
  //       <div className={styles.value}>5.5%</div>
  //       <div className={styles.label}>预测进店率</div>
  //     </div>

  //     {Array.isArray(list) && !!list.length && <div className={styles.metricsWrapper}>
  //       {list.map((item, index) => (
  //         <Item key={index} item={item} />
  //       ))}
  //     </div>}

  //   </div>
  // </Block>);
};


// /**
//  * 核心指标分析-指标项
//  * @description
//  * @demo
//  */
// const Item:FC<{
//   item,
// }> = ({ item }) => {

//   /* state */

//   /* hooks */

//   /* methods */

//   return (<div className={styles.item}>
//     <div className={styles.valueWrapper}>
//       <span className={styles.value}>{item.value}</span>
//       <span className={styles.unit}>{item.unit}</span>
//     </div>
//     <div className={styles.label}>{item.label}</div>
//     <img src={item.img} className={styles.icon}/>
//     {!!item.footer && <div className={styles.footer}>{item.footer}</div>}
//   </div>);
// };


export default Component;
